// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { getTranslatedImage as getTranslatedImageHelper } from "#/common/ModuleHelpers";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";
import moment from "moment";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class NewsListModuleItem extends Vue {
  @Prop()
  public news!: object;

  @Prop()
  public date!: string;

  @Prop()
  public link!: string;

  @Prop()
  public lang!: string;

  @Prop()
  public country!: string;

  public getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }

  public get getLink() {
    if (
      this.news["content"].hasOwnProperty("alternativeLink") &&
      this.news["content"]["alternativeLink"] &&
      this.news["content"]["alternativeLink"]["href"]
    ) {
      return this.news["content"]["alternativeLink"]["href"];
    }
    return this.link
      .replace("{lang}", this.lang)
      .replace("{country}", this.country);
  }

  get dateString() {
    if (this.date) {
      let d = moment(this.date);
      return d.format("DD.MM.YYYY");
    } else {
      return "";
    }
  }
}
